import AgentLicenses from 'Agent/AgentInformation/components/AgentLicenses';
import AgentNews from 'Agent/AgentInformation/components/AgentNews';
import Hierarchy from 'Agent/AgentInformation/components/Hierarchy';
import React from 'react';
import {Route, Switch} from 'react-router';
import {RouteComponentProps} from 'react-router-dom';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {AgentInformationRouteConstants} from './AgentInformationRouteConstants';
import RateGenerators from './components/RateGenerators';

type AgentInformationRouteProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

export default ({match, selectedAgency}: AgentInformationRouteProps) => {
  return (
    <Route
      path={`${match.url}/agentInformation`}
      render={() => (
        <Switch>
          <Route
            exact
            path={AgentInformationRouteConstants.AGENT_NEWS}
            render={routeProps => <AgentNews {...routeProps} />}
          />
          <Route
            exact
            path={AgentInformationRouteConstants.AGENT_LICENSES}
            render={routeProps => <AgentLicenses {...routeProps} selectedAgency={selectedAgency} />}
          />
          <Route
            exact
            path={AgentInformationRouteConstants.HIERARCHY}
            render={routeProps => <Hierarchy {...routeProps} selectedAgency={selectedAgency} />}
          />
          <Route
            exact
            path={AgentInformationRouteConstants.NY_RATE_GENERATORS}
            render={() => <RateGenerators selectedAgency={selectedAgency} />}
          />
          ,
        </Switch>
      )}
    />
  );
};
